import SwapIcon from './SwapIcon'

export default SwapIcon
